module.exports = __webpack_public_path__ + "img/47.b66ef48d.png";